<template>
  <div class="page_box" v-if="listBox == true">
    <div class="page_option_box">
      <div class="option_box">
        <!-- <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-back"
          @click="goBack()"
          >返回宿舍楼房间</el-button
        > -->
        <el-page-header @back="goBack">
        </el-page-header>
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="openAddBox()"
          >添加</el-button
        >
        <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          @click="batchDeletePerson()"
          :disabled="personDelList.length < 1 ? true : false"
          >删除</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          type="text"
          placeholder="请输入名字"
          v-model.trim="requestParams.personnelPhone"
          size="mini"
          class="textInput"
        ></el-input>
        &nbsp;&nbsp;
        <el-button type="primary" size="mini" plain icon="el-icon-search"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <!-- 人员列表 -->
      <div class="school_table_box">
        <el-table
          :data="personData.list"
          height="100%"
          class="table_box table"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" align="center"> </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                personData.pageSize * (personData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="personnelNickname" label="名字" align="center">
          </el-table-column>

          <el-table-column prop="personnelPhone" label="手机号" align="center">
          </el-table-column>
          <el-table-column prop="addTime" label="创建日期" width="150" align="center">
            <template slot-scope="rowData">
              {{ $Common.dateFormatDate(rowData.row.addTime) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" column-key="index" width="180" align="center">
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="openEditBox(scope.row)"
                :underline="false"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                type="primary"
                @click="delPerson(scope.row)"
                :underline="false"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="personData.pageNum"
          :page-size="personData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="personData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
  <!-- 新增人员 -->
  <div class="page_box" v-else-if="addBox == true">
    <div class="page_option_box" style="font-size:18px">
      新增房间人员
    </div>
    <div class="page_table_box">
      <el-tree
        class="tree"
        style="margin-top:5px"
        v-loading="treeLoading"
        ref="tree"
        :load="loadNode"
        :data="studentList"
        node-key="id"
        :props="defaultProps"
        show-checkbox
        @check-change="handleCheckChange"
      >
      </el-tree>
      <div style="padding:20px">
        <el-button size="small" type="primary" @click="add()"
          >确定提交</el-button
        >
        <el-button size="small" @click="closeBox()">返回</el-button>
      </div>
    </div>
  </div>

  <!-- 编辑人员信息 -->
  <div class="page_box" v-else>
    <div class="page_option_box" style="font-size:18px">
      编辑房间人员
    </div>
    <div class="page_table_box">
      <el-form label-width="120px" class="demo-ruleForm" ref="ruleForm" :model="editPerson" :rules="editRules">
        <el-form-item label="名字名称" prop="personnelNickname">
          <el-input
            v-model.trim="editPerson.personnelNickname"
            placeholder="请输入名字"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="personnelPhone">
          <el-input
            v-model.trim="editPerson.personnelPhone"
            placeholder="请输入手机号"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="edit('ruleForm')"
            >确定提交</el-button
          >
          <el-button size="small" @click="closeBox()">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import JobStructure from "@/components/JobStructure";
export default {
  name: "",
  components: {
    JobStructure
  },
  props: {},
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      listBox: true,
      addBox: false,
      editBox: false,
      roomId: "",
      // 新增人员数据
      addPerson: [],
      // 编辑名字信息
      editPerson: {
        id: "",
        personnelNickname: "",
        personnelPhone: ""
      },
      // 人员列表
      personData: {
        pageNum: 1, // 第几页
        pageSize: 20, // 一页多少个
        total: 0, // 总条数
        pages: 0, // 总页数
        list: [] // 数据列表
      },
      // 获取人员列表的请求参数
      requestParams: {
        roomId: "",
        pageNum: 1,
        pageSize: 20,
        personnelNickname: ""
      },
      // 批量删除人员的ID列表
      personDelList: [],
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      studentList: [],
      editRules:{
         personnelNickname: [
            { required: true, message: ' ', trigger: 'blur' }
          ],
          personnelPhone: [
            { required: true, validator: checkPhone, trigger: 'blur' }
          ],
      }
    };
  },
  watch: {},
  computed: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 打开新增
    openAddBox() {
      this.listBox = false;
      this.addBox = true;
      this.getStudent();
    },
    // 编辑名字信息
    openEditBox(info) {
      this.editPerson.id = info.id;
      this.editPerson.personnelNickname = info.personnelNickname;
      this.editPerson.personnelPhone = info.personnelPhone;
      this.listBox = false;
      this.editBox = true;
    },

    // 关闭新增
    closeBox() {
      this.listBox = true;
      this.addBox = false;
      this.editBox = false;

      this.addPerson.personnelNickname = "";
      this.addPerson.personnelPhone = "";

      this.editPerson.id = "";
      this.editPerson.personnelNickname = "";
      this.editPerson.personnelPhone = "";
    },

    // 数据翻页
    handleCurrentChange(val) {
      this.personData.pageNum = val;
      this.getPersonList();
    },
    handleSelectionChange(val) {
      // console.log(val)
      this.personDelList = [];
      val.forEach((element) => {
        this.personDelList.push(element.id);
      });
    },
    // 删除人员
    delPerson(thisData, thisRow) {
      // console.log(thisData)
      // console.log(thisRow)
      // return
      this.$confirm("此操作将永久删除此人员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        let requestData = {
          id: thisData.id
        };
        let res = await this.$Http.delApartmentPerson(requestData, true);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getPersonList();
        } else if (res.code == 101) {
        } else {
          this.$message({
            type: "error",
            message: res.messsage
          });
        }
      });
    },
    // 获取名字列表
    async getPersonList() {
      let res = await this.$Http.getApartmentPerson(this.requestParams);
      if (res.code == 200) {
        // console.log(res)
        this.personData.pageNum = res.data.pageNum || 1;
        this.personData.pageSize = res.data.pageSize || 20;
        this.personData.total = res.data.total || 0;
        this.personData.pages = res.data.pages || 0;
        this.personData.list = res.data.list || [];
      } else if (res.code == 101) {
        this.personData.total = 0;
        this.personData.list = [];
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      console.log();
      let roomId = this.roomId;
      let selectList = this.$refs.tree.getCheckedNodes();
      console.log(selectList);
      let personList = [];
      selectList.map((item) => {
        if (item.children.length == 0) {
          let obj = {
            roomId: roomId,
            personnelNickname: item.label
          };
          personList.push(obj);
        }
      });
      console.log(personList);
      this.addPerson = personList;
    },
    handleNodeClick(data) {
      console.log(data);
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve([{ name: "region1" }, { name: "region2" }]);
      }
      if (node.level > 3) return resolve([]);

      var hasChild;
      if (node.data.name === "region1") {
        hasChild = true;
      } else if (node.data.name === "region2") {
        hasChild = false;
      } else {
        hasChild = Math.random() > 0.5;
      }

      setTimeout(() => {
        var data;
        if (hasChild) {
          data = [
            {
              name: "zone" + this.count++
            },
            {
              name: "zone" + this.count++
            }
          ];
        } else {
          data = [];
        }
        resolve(data);
      }, 500);
    },
    // 添加名字
    async getStudent() {
      let req = {
        schoolId: this.$store.state.schoolId
      };

      this.treeLoading = true;
      let res = await this.$Http.getStudent(req);
      console.log(res);
      if (res.code == 200) {
        let data = res.data || [];
        let list = data.map((item) => {
          let obj = {
            id: item.classId,
            value: item.classId,
            label: item.className,
            children: []
          };
          obj.children = item.studentList.map((element) => {
            let objTemp = {
              id: element.studentId,
              value: element.studentId,
              label: element.studentName,
              children: []
            };
            return objTemp;
          });
          return obj;
        });
        console.log(list);
        this.studentList = list;
        this.treeLoading = false;
      } else if (res.code == 101) {
        this.studentList = [];
        this.treeLoading = false;
      } else {
        this.treeLoading = false;
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(res)
    },
    // 添加名字
    async add() {
      if (this.addPerson.length == 0) {
        this.$message("请选择学生！");
        return;
      }
      let req = this.addPerson;
      let res = await this.$Http.addApartmentPerson(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "添加成功"
        });
        this.closeBox();
        this.getPersonList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
      // console.log(res)
    },
    // 保存名字信息
    edit(formName) {
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.editInfo()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    async editInfo(){
let res = await this.$Http.editApartmentPerson(this.editPerson);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功"
        });
        this.closeBox();
        this.getPersonList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 批量删除人员
    batchDeletePerson() {
      if (this.personDelList.length == 0) {
        this.$message("请先选择您要删除的人员");
        return false;
      }
      this.$confirm("此操作将永久删除这些人员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let requestData = {
            id: this.personDelList.join(",")
          };
          // console.log(requestData)
          let res = await this.$Http.delApartmentPerson(requestData, true);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getPersonList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    }
  },
  created() {
    let roomId = JSON.parse(sessionStorage.getItem("apartmentPersons")).id;
    this.requestParams.roomId = roomId;
    this.roomId = roomId;
    this.getPersonList();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.tree {
  max-height: 500px;
  overflow: scroll;
}
.el-form {
  .el-input {
    width: 300px;
  }
}
</style>
